export {
  default,
  CONTENT_TYPE,
  CONTENT_TYPE_FAST,
  CONTENT_TYPE_SLOW,
} from './Content';
